import { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { TraderaView } from "../VIEW/TraderaView";
import { useAuth } from "../FIREBASE/useAuth";
import routeUrls from "../COMPONENTS/navbar/navLink";

function TraderaPage() {
  const { user, loading } = useAuth();
  const history = useHistory();

  useEffect(() => {
    if (!loading && !user) history.replace(`${routeUrls.LOGIN}?from=${routeUrls.TRADERA}`);
  }, [user, loading]);

  if (loading || !user) return null;
  return <TraderaView uid={user.uid} />;
}

export default TraderaPage;
